export default "__VITE_ASSET__Dz_IgJW2__"